/*
 * View for topic response translation (modal)
 */

define(["marionette", "./template/responseTranslationModalTemplate.html"], function (
  Marionette,
  ResponseTranslationModalTemplate,
) {
  const ResponseTranslationModalView = {};

  ResponseTranslationModalView.responseTranslationModalView = Marionette.Layout.extend({
    template: ResponseTranslationModalTemplate,
    regions: {
      htmlEditor: ".html-editor",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
    events: {
      "click #translateButton": "onTranslateClicked",
    },
    disableDoneButton: function () {
      this.$el.find("#doneButton").prop("disabled", true);
    },
    enableDoneButton: function () {
      this.$el.find("#doneButton").prop("disabled", false);
    },
    disableCancelButton: function () {
      this.$el.find("#cancelButton").prop("disabled", true);
    },
    enableCancelButton: function () {
      this.$el.find("#cancelButton").prop("disabled", false);
    },
    disableTranslateButton: function () {
      this.$el.find("#translateButton").prop("disabled", true);
    },
    enableTranslateButton: function () {
      this.$el.find("#translateButton").prop("disabled", false);
    },
    onTranslateClicked: function () {
      const targetLanguageId = +this.$el.find("#targetLanguageSelect").val();
      this.trigger("translateResponse", targetLanguageId);
    },
  });

  return ResponseTranslationModalView;
});
